<template>
    <ModalComponent
        :name="'test-venta-warning-' + evento.id + '-' + sesion.id"
        title="ENLACE PARA USO INTERNO"
        @close="close"
    >
        <div class="row">
            <div class="col-12">
                <p class="text-justify text-lg" style="word-spacing: -2px;">
                    Este enlace es solo para uso interno.<br/>
                    No se debe publicar en ningún sitio web ni debe distribuirse al público general.
                </p>
            </div>

            <div class="col-12">
                <div class="d-md-flex justify-content-center text-center">
                    <Button
                        v-if="showVentaNormal"
                        data-cy="test-venta-normal"
                        class="btn btn-primary"
                        @click="openLink(ventaNormal)"
                    >
                        Ir a la venta normal
                    </Button>

                    <Button
                        v-if="showVentaAbonado"
                        data-cy="test-venta-abonado"
                        class="btn btn-primary ml-md-2 mt-2 mt-md-0"
                        @click="openLink(ventaAbonado)"
                    >
                        Ir a la venta como abonado
                    </Button>

                    <Button
                        v-if="showVentaAmigoAbonado"
                        data-cy="test-venta-amigoabonado"
                        class="btn btn-primary ml-md-2 mt-2 mt-md-0"
                        @click="openLink(evento.lfp_id ? ventaNormal : ventaAmigoAbonado)"
                    >
                        Ir a la venta como amigo abonado
                    </Button>
                </div>
            </div>
        </div>
    </ModalComponent>
</template>

<script setup>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import { computed } from 'vue';
    import { useRouter } from '@/composables/common/router/useRouter';

    const props = defineProps({
        evento: {
            type: Object,
            required: true
        },
        sesion: {
            type: Object,
            required: true
        }
    });

    const emit = defineEmits();
    const router = useRouter();

    const showVentaNormal = computed(() => {
        return !props.evento.solo_abonados;
    });

    const showVentaAbonado = computed(() => {
        return props.evento.descuento_abonado;
    });

    const showVentaAmigoAbonado = computed(() => {
        return props.evento.amigo_abonado;
    });

    const ventaNormal = computed(() => {
        return `/eventos/${props.evento?.id}/${props.sesion?.id}/${props.evento?.slug}?venta_online=test`;
    });

    const ventaAbonado = computed(() => {
        return `/eventos/${props.evento?.id}/${props.sesion?.id}/abonados?venta_online=test`;
    });

    const ventaAmigoAbonado = computed(() => {
        return `/eventos/${props.evento?.id}/${props.sesion?.id}/amigos-abonados?venta_online=test`;
    });

    const close = () => {
        emit('close', 'test-venta-warning-' + props.evento.id + '-' + props.sesion.id);
    };

    const openLink = link => {
        router.push(link);
    };
</script>
